import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Menu} from 'semantic-ui-react'
import PropTypes from 'prop-types';

import {hasPermission, isLoggedIn} from "../../../reducer";
import {Link} from 'react-router-dom';
import {Translate} from "react-localize-redux";
import NavLink from "../../../components/NavLink";


class ClockLink extends Component {

    render() {

        if (this.props.loggedIn) {
            if (this.props.hasPermission) {
                if (this.props.mobile) {
                    return (
                        <Translate>
                            {({translate}) =>
                                <Menu.Item name={translate('inventory.links.menu')} as={Link} to={'/inventory'}/>
                            }
                        </Translate>
                    );
                }
                return (
                    <Translate>
                        {({translate}) =>
                            <NavLink to={'/inventory'}>{translate('inventory.links.menu')}</NavLink>
                        }
                    </Translate>

                );
            }
            return null;
        }

        return null;
    }
}

ClockLink.contextTypes = {
    router: PropTypes.object
};


const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state),
    hasPermission: hasPermission(state, 'stockTaking'),
});


export default connect(
    mapStateToProps,
    null,
    null
)(ClockLink)



// WEBPACK FOOTER //
// ./src/scenes/Inventory/Links/index.js